var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedProfilesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 4.5,
    fill: "white",
    stroke: "#F8F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3872_1222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6.35193L15.1763 12.9993L8 14.1042L13.1245 19.3115L11.9055 26.648L18.5 23.2252L25.0945 26.648L23.8755 19.3109L29 14.1042L21.8237 12.9993L18.5 6.35193ZM17.8848 19.672L15.7843 17.5715L16.6543 16.7016L17.8848 17.932L20.3457 15.4711L21.2157 16.3411L17.8848 19.672Z",
    fill: "url(#paint0_linear_3872_1222)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3872_1222",
    x1: 18.5,
    y1: 6.35193,
    x2: 18.5,
    y2: 26.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3872_1222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(8 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedProfilesIcon);
export default __webpack_public_path__ + "static/media/FeaturedProfiles-icon.2c7c5c5149d69be9baa70989a659e2fe.svg";
export { ForwardRef as ReactComponent };